import PageTemplate from "@/components/page-template/PageTemplate";
import SubscriptionPlanForm from "./SubscriptionPlanForm";

export default function CreateSubscriptionPlanPage() {
  return (
    <PageTemplate
      title="New subscription plan"
      description="Define a plan customers can subscribe to (e.g. Monthly, Annual)."
    >
      <SubscriptionPlanForm />
    </PageTemplate>
  );
}
